module.exports = __webpack_public_path__ + "static/hero-left2-1fc0973cbcb0c062240b5bc08044d417.svg";